import React, { useRef } from "react";
import SuggestionPills from "web/react/components/feeds-filters/feeds-suggested-filters-pills/feeds-suggested-filters-pills";
import FeedsFilterBar from "web/react/components/feeds-filters/feeds-filter-bar/feeds-filter-bar";
import { UniversalFiltersData } from "web/types/universal-filters";
import { useFilterManager } from "web/react/components/feeds-filters/hooks/use-filter-manager";
import withReduxProvider from "web/react/redux-provider";

interface FilterContainerProps {
    filters: UniversalFiltersData;
}

export function FilterContainerTop({ filters }: FilterContainerProps): JSX.Element {
    let filterManager = useFilterManager(filters);
    let pillContainerRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={pillContainerRef}>
            <FeedsFilterBar
                selectedFilterInfo={filterManager.selectedFilterInfo}
                onClick={filterManager.onClick}
            />
            <SuggestionPills
                suggestedFilterInfo={filterManager.suggestedFilterInfo}
                onClick={filterManager.onClick}
            />
        </div>
    );
}

export default withReduxProvider(FilterContainerTop);
